import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import injectJss from 'react-jss';
import HeadingForm from '../../layout/HeadingForm';
import { mapClaimData, moduleNames } from '../../services';
import ContentWrapper from '../../components/ContentWrapper/ContentWrapper';
import ErgoNavButton from '../../components/ErgoNavButton';
import { legalConsentProps } from '../../models/panels';
import { getHeadingData } from '../../helpers/formData/legalProtectionFormData';
import {
  ContactDetails,
  FileDetails,
  AffectedAreaOfLifeDetails,
  YourMessageDetails,
} from './sections';
import { extractTemplateData } from '../../helpers/pdfHelpers';
import styles from './styles.jss';

class LegalProtectionSummaryPage extends React.PureComponent {
  state = {
    mappedFormData: {},
  };

  componentDidMount() {
    const { formData } = this.props;
    this.setState({ mappedFormData: mapClaimData(formData, moduleNames.LEGAL_PROTECTION).data },
      () => extractTemplateData('summaryPageWrapper'));
  }

  render() {
    const {
      isValid, localePath, classes, onClick, formData,
    } = this.props;
    const { mappedFormData } = this.state;
    const { t } = this.context;

    const defaultProps = {
      formData: mappedFormData,
      localePath,
      className: classes.detailsWrapper,
      whatDocuments: formData[moduleNames.LEGAL_PROTECTION]
        && formData[moduleNames.LEGAL_PROTECTION]['upload-documents_what-documents'],
    };

    return (
      <ContentWrapper>
        <HeadingForm
          value={t(`${localePath}.heading`, {
            fullName: getHeadingData(mappedFormData),
          })}
          commentValue={t(`${localePath}.comment`)}
        />
        <div id="summaryPageWrapper">
          <ContactDetails {...defaultProps} />
          <AffectedAreaOfLifeDetails {...defaultProps} />
          <YourMessageDetails {...defaultProps} />
          <FileDetails {...defaultProps} />
        </div>

        <div className="esc_grid">
          <div className={`esc_grid__wrapper ${classes.gridWrapper}`}>
            <div className="esc_col esc_col-12 esc_col-s-3 esc_col-m-2">
              <ErgoNavButton previous onClick={onClick} shouldNavigateAfterClick type="submit" />
            </div>
            <div className="esc_col esc_col-12 esc_col-s-8 esc_col-m-4">
              <ErgoNavButton
                title={`${localePath}.ok`}
                onClick={onClick}
                disabled={!isValid}
                shouldNavigateAfterClick
                type="submit"
              />
            </div>
          </div>
        </div>
      </ContentWrapper>
    );
  }
}

const mapStateToProps = ({ formData }) => ({ formData });

// ToDo: change module name for SummaryPageProps
LegalProtectionSummaryPage.propTypes = legalConsentProps.props;
LegalProtectionSummaryPage.defaultProps = legalConsentProps.defaultProps;
LegalProtectionSummaryPage.contextTypes = {
  t: PropTypes.func,
};

export { LegalProtectionSummaryPage as LegalProtectionSummaryPagePlain };
export default compose(
  connect(
    mapStateToProps,
    null,
  ),
  injectJss(styles),
)(LegalProtectionSummaryPage);
